
export const GraphLegends = (props: IGraphLegendProps) => {

    const getLegendClass = () => {
        const defaultClass = 'dot__legend';
        return (props.legendClass) ? props.legendClass + ' ' + defaultClass  : defaultClass;
    }

    return (
        <div className="react-component">
            <div className="graph-legend">
                <div className="align-item zf-text-color-black-80">
                    {
                        props.legends.map((legend) => {
                            return (
                                <div key={`legend_${legend.value}`} className="zf-padding-r-m">
                                    <span className={getLegendClass()} style={{backgroundColor: legend.iconColor}}></span>
                                    <span className={(props.textClass ? props.textClass : 'text')}> {legend.value} </span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export interface IGraphLegendProps {
    legends: Array<IGraphLegend>;
    legendClass?: string;
    textClass?: string;
}

export interface IGraphLegend {
    iconColor: string;
    value: string;
}
